import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("non_soaked_products")

export class NonSoakedProductsEntity {

    @PrimaryGeneratedColumn("increment",{name:'non_soaked_product_id'})
    nonSoakedProductId:number;

    @Column('varchar',{
        name:'lot_code',
        nullable:false,
        length:50
    })
    lotCode: string

    @Column('enum',{
        name:'operation',
        nullable:false,
        enum:OperationTypeEnum
    })
    operation: OperationTypeEnum

    @Column('varchar',{
        name:'count',
        nullable:false,
    })
    count: string

    @Column('varchar',{
        name:'grade',
        nullable:false,
        length:50
    })
    grade: string

    @Column('varchar',{
        name:'product',
        nullable:false,
        length:100
    })
    product: string

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length:50
    })
    createdUser: string | null;

    @Column('int',{
        name:'plant_id',
        nullable:false,
    })
    plantId: number

    @Column('int',{
        name:'year'
    })
    year:number
    
    @Column('varchar',{
        name:'from_product',
        length:30
    })
    fromproduct : string

    @Column('datetime',{
        name:'date'
    })
    date : Date
}